<template>
<div :class="_class">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        is_auto: {
            type: Boolean,
            default: false
        },
        xl: {
            type: [String, Object],
            default: '0',
        },
        lg: {
            type: [String, Object],
            default: '0',
        },
        md: {
            type: [String, Object],
            default: '0',
        },
        sm: {
            type: [String, Object],
            default: '0',
        },
        xs: {
            type: [String, Object],
            default: '0',
        },
    },
    computed: {
        _class: function() {
            let _class = []

            let _sizes = ['xl', 'lg', 'md', 'sm', 'xs']

            _sizes.forEach(size => {
                if(this[size] !== '0') {
                    if(size === 'xs') {
                        _class.push('col-'+this[size])
                    }else {
                        _class.push('col-'+size+'-'+this[size])
                    }
                }

                if(typeof this[size] === 'object') {
                    if(this[size].span && this[size].span !== '0') {
                        if(size === 'xs') {
                            _class.push('col-'+this[size].span)
                        }else {
                            _class.push('col-'+size+'-'+this[size].span)
                        }
                    }
                    if(this[size].offset && this[size].offset !== 0) {
                        if(size === 'xs') {
                            _class.push('col-'+this[size].offset)
                        }else {
                            _class.push('col-'+size+'-'+this[size].offset)
                        }
                    }
                }
            })

            if(_class.length === 0 || this.is_auto === true) {
                _class.push('col')
            }

            return _class
        }
    }
}
</script>

<style>

</style>